import AbstractApiUtils from "services/cores/abstractApiUtils";

import { toast } from "react-toastify";
import DisplayRowContent from "scenes/Displays/components/DisplayRowContent";
import DisplaysActioner from "services/displays/actioner";
import IntlUtils from "services/intl/utils";

function getFilters(type = "default", state) {
  let data = {};
  let filters = {};

  return {
    ...data,
    filters,
  };
}

class DisplaysUtils extends AbstractApiUtils {
  getFilters = getFilters;

  formatListFromApi = (list) => {
    return {
      items: this.formatDisplaysFromApi(list?.displays || []),
    };
  };

  formatDisplaysFromApi = (displays = [], config) => {
    const displaysToDisplay = displays;

    return displaysToDisplay.map((display) =>
      this.formatDisplayFromApi(display, config)
    );
  };

  formatDisplayFromApi = (display, config = []) => {
    const displayConfig = config.find(
      (config) =>
        (display?.id || display?.display_id) ===
        (config?.display_id || config?.id)
    );

    return {
      ...displayConfig,
      ...display,
      apiType: display?.type,
      type: "display",
      options: {
        ...(display?.options || {}),
        ...(displayConfig?.display || {}),
      },
    };
  };

  getSelectedLayer = (displaysState) => displaysState?.map?.selectedLayers?.[0];

  getDisplayData = (display) => {
    if (!display) return null;

    return [
      {
        toggle: true,
        value: display?.meta_data?.label || display?.name,
        type: {
          name: "label",
          color: "turquoise",
        },
      },
      {
        toggle: true,
        children: <DisplayRowContent display={display} />,
        type: {
          name: "children",
        },
      },
      {},
      {},
    ];
  };

  getFormDefaultValues = (display, displays) => {
    const ruleDetails = this.getRuleDefautlValues(display);
    return {
      id: display.id,
      stand_by: display?.client_rule?.stand_by_config?.force_stand_by ?? false,
      rule: {
        ...ruleDetails,
        is_active: display?.client_rule?.rule?.is_active ?? false,
        ...this.getRuledefaultValuesForPicto(display, displays),
      },
      emergency_rule: display?.emergency_rule?.rule?.is_active ?? false,
    };
  };

  getRuleDefautlValues = (display) => {
    if (display?.type === "TTS") {
      return this.getRuleDefaultValuesForTTS(display);
    }
    const rule =
      display?.client_rule?.rule?.rule_overrides?.[
        display?.client_rule?.rule?.current_rule
      ];
    const color =
      rule !== undefined
        ? parseInt(rule?.color ?? rule?.data?.substring(0, 1), 10)
        : display?.available_colors?.[0]?.symbol;
    const text = rule?.color ? rule?.data : rule?.data?.substring(1);
    const dataIsIncludedToAvailableText =
      display?.available_texts?.includes(text);
    return {
      text: dataIsIncludedToAvailableText ? text : "custom",
      color,
      custom_text: dataIsIncludedToAvailableText ? "" : text,
    };
  };

  getRuleDefaultValuesForTTS(display) {
    const rule =
      display?.client_rule?.rule?.rule_overrides?.[
        display?.client_rule?.rule?.current_rule
      ];
    const color =
      rule !== undefined
        ? parseInt(rule.color, 10)
        : display?.available_colors?.[0]?.symbol;
    const text = rule?.data;
    const dataIsIncludedToAvailableText =
      display?.available_texts?.includes(text);
    return {
      text: dataIsIncludedToAvailableText ? text : "custom",
      color,
      custom_text: dataIsIncludedToAvailableText ? "" : text,
    };
  }

  getRuledefaultValuesForPicto(display, displays) {
    if (!this.hasPictogram(display)) {
      return { pictogram: undefined };
    }
    const picto = displays?.find(
      (d) => d.id === display?.children?.find((d) => d.type === "PICTO")?.id
    );

    const rule =
      picto?.client_rule?.rule?.rule_overrides?.[
        picto?.client_rule?.rule?.current_rule
      ];

    return { pictogram: parseInt(rule?.data, 10) };
  }

  isCustom(text) {
    return text === "custom";
  }

  updateEmergencyRule(displayId, isActive) {
    const intl = IntlUtils.getIntlInstance();
    return this.executeUpdateEmergencyRule(displayId, isActive).catch((err) => {
      let msg = intl.messages["toast.errors.errorOccuredContactSupport"];
      if (err.status === 403) {
        msg = intl.formatMessage({ id: "toast.errors.displays.action" });
      }
      toast(msg, {
        position: toast.POSITION.BOTTOM_RIGHT,
        type: toast.TYPE.ERROR,
      });
      return Promise.reject(err);
    });
  }

  executeUpdateEmergencyRule(displayId, isActive) {
    return DisplaysActioner.updateEmergencyRule(displayId, isActive);
  }

  updateStandBy(displayId, display, standBy) {
    const intl = IntlUtils.getIntlInstance();
    return this.executeUpdateStandBy(displayId, standBy)
      .then(() => {
        if (this.hasPictogram(display)) {
          return this.executeUpdateStandBy(
            display?.children?.find((d) => d.type === "PICTO")?.id,
            standBy
          );
        }
      })
      .catch((err) => {
        let msg = intl.messages["toast.errors.errorOccuredContactSupport"];
        if (err.status === 403) {
          msg = intl.formatMessage({ id: "toast.errors.displays.action" });
        }

        toast(msg, {
          position: toast.POSITION.BOTTOM_RIGHT,
          type: toast.TYPE.ERROR,
        });
        return Promise.reject(err);
      });
  }

  executeUpdateStandBy(displayId, standBy) {
    return DisplaysActioner.updateStandBy(displayId, standBy);
  }

  updateRule(displayId, display, ruleFields) {
    const intl = IntlUtils.getIntlInstance();
    return this.executeUpdateRule(displayId, {
      text: this.isCustom(ruleFields?.text)
        ? ruleFields?.custom_text
        : ruleFields?.text,
      color: ruleFields?.color,
      is_active: ruleFields?.is_active,
    })
      .then(() => {
        if (this.hasPictogram(display)) {
          return this.executeUpdateRule(
            display?.children?.find((d) => d.type === "PICTO")?.id,
            {
              is_active: ruleFields?.is_active,
              color: ruleFields?.pictogram,
            }
          );
        }
      })
      .catch((err) => {
        let msg = intl.messages["toast.errors.errorOccuredContactSupport"];
        if (err.status === 403) {
          msg = intl.formatMessage({ id: "toast.errors.displays.action" });
        }
        toast(msg, {
          position: toast.POSITION.BOTTOM_RIGHT,
          type: toast.TYPE.ERROR,
        });
        return Promise.reject(err);
      });
  }

  executeUpdateRule(displayId, rule) {
    return DisplaysActioner.updateRule(displayId, rule);
  }

  hasPictogram(display) {
    return display?.children?.some((d) => d.type === "PICTO");
  }

  getPictogram(display, displays) {
    return displays?.find(
      (disp) =>
        display?.children?.find((d) => d.type === "PICTO")?.id === disp.id
    );
  }
}

export { getFilters };
export default new DisplaysUtils();
